<div class="tab-section" >
    <div class="dropdown-select">
        
        <div class="d-flex">
            <p class="textBlueBold mr-10">Division : </p>
        <p-dropdown 
            [options]="dropDownData" 
            [(ngModel)]="selectedDivision" 
            optionLabel="label"
            optionValue="value"
            [autoDisplayFirst]="true"
            styleClass="ml-10 ht-35"
            (onChange)="onDivisionChange($event)">
        </p-dropdown>
        </div>
    </div>
    
    <p-table [value]="removedFilterData" class='mt-10' [scrollable]="true" id="StyleTable" scrollHeight="400px">
        <ng-template pTemplate="header">
            <tr>
                <th>Division</th>
                <th>Section</th>
                <th>User Id</th>
                <th>TLR#</th>
                <th>TLR Status</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td>{{row.division_name}}</td>
                <td>{{row.section_name}}</td>
                <td>{{row.engineering_cai}}</td>
                <td [ngClass]="row.cssClass" >{{row.tag_number}}</td>
                <td [ngClass]="row.cssClass" >{{row.status}}</td>
                <td><a (click)="details(row)" class="link-underline">Details</a></td>
            </tr>
        </ng-template>
    </p-table>
</div>
<!-- <div *ngIf="removedData.length == 0">
    <p class="messageTitle">There are no TLR's that have been OA (Removed)</p>
</div> -->